import React from 'react';
import MonitoringBoard from './MonitoringBoard';
import './Monitoring.css';

function Monitoring() {
  return (
    <section className="aqp-section aqp-section--warm aqp-mon" data-screen-label="Monitoring">
      <div className="aqp-mon__inner">
        <div className="aqp-reveal aqp-mon__head">
          <span className="aqp-eyebrow aqp-mon__eyebrow">Real-time monitoring &amp; alerts</span>
          <h2 className="aqp-mon__h2">
            We watch the signals that say something is <span>going wrong</span> before it gets expensive.
          </h2>
          <p className="aqp-mon__lede">
            If a problem starts to build, you hear about it that day or that week, not at the end of the project.
          </p>
        </div>
        <div className="aqp-reveal aqp-mon__board">
          <MonitoringBoard />
        </div>
      </div>
    </section>
  );
}

export default Monitoring;
